import {
  GET_MODIFIER_GROUPS_REQUESTED,
  GET_MODIFIER_GROUPS_SUCCEEDED,
  GET_MODIFIER_GROUPS_FAILED,
  UPDATE_MODIFIER_GROUP_REQUESTED,
  UPDATE_MODIFIER_GROUP_SUCCEEDED,
  UPDATE_MODIFIER_GROUP_FAILED,
  CREATE_MODIFIER_GROUP_REQUESTED,
  CREATE_MODIFIER_GROUP_SUCCEEDED,
  CREATE_MODIFIER_GROUP_FAILED,
  SET_MODIFIER_GROUPS_INDEXES,
  SET_MODIFIER_GROUPS_SORTING_MODE,
  SEARCH_MODIFIER_GROUP_SUCCEEDED,
} from './constants'
import api from 'utils/api'

export const getModifierGroupsRequested = () => ({
  type: GET_MODIFIER_GROUPS_REQUESTED,
})

export const getModifierGroupsSucceeded = (payload) => ({
  type: GET_MODIFIER_GROUPS_SUCCEEDED,
  payload,
})

export const getModifierGroupsFailed = () => ({
  type: GET_MODIFIER_GROUPS_FAILED,
})

export const loadModifierGroups = (venueUuid) => (dispatch) => {
  dispatch(getModifierGroupsRequested())

  return api
    .fetchModifierGroups(venueUuid)
    .then((response) =>
      dispatch(
        getModifierGroupsSucceeded(response?.data?.itemCategories)
      )
    )
    .catch(() => dispatch(getModifierGroupsFailed()))
}

export const createModifierGroupRequested = () => ({
  type: CREATE_MODIFIER_GROUP_REQUESTED,
})

export const createModifierGroupSucceeded = (payload) => ({
  type: CREATE_MODIFIER_GROUP_SUCCEEDED,
  payload,
})

export const createModifierGroupFailed = () => ({
  type: CREATE_MODIFIER_GROUP_FAILED,
})

export const createModifierGroup = (data) => (dispatch) => {
  dispatch(createModifierGroupRequested())

  const params = { itemCategories: data }

  return api
    .createCategory(params)
    .then((response) =>
      dispatch(
        createModifierGroupSucceeded(response?.data?.itemCategories)
      )
    )
    .catch(() => dispatch(createModifierGroupFailed()))
}

export const updateModifierGroupRequested = () => ({
  type: UPDATE_MODIFIER_GROUP_REQUESTED,
})

export const updateModifierGroupSucceeded = (payload) => ({
  type: UPDATE_MODIFIER_GROUP_SUCCEEDED,
  payload,
})

export const updateModifierGroupFailed = () => ({
  type: UPDATE_MODIFIER_GROUP_FAILED,
})

export const updateModifierGroup = (data) => (dispatch) => {
  dispatch(updateModifierGroupRequested())

  const params = { itemCategories: data }

  return api
    .updateCategory(params)
    .then((response) =>
      dispatch(
        updateModifierGroupSucceeded(response?.data?.itemCategories)
      )
    )
    .catch(() => dispatch(updateModifierGroupFailed()))
}

export const setModifierGroupsIndexes = (payload) => ({
  type: SET_MODIFIER_GROUPS_INDEXES,
  payload,
})

export const setModifierGroupsSortingMode = (payload) => ({
  type: SET_MODIFIER_GROUPS_SORTING_MODE,
  payload,
})

export const searchModifierGroup = (payload) => ({
  type: SEARCH_MODIFIER_GROUP_SUCCEEDED,
  payload,
})
